






import Vue from 'vue'
import BaseSearchHandler from '~/components/car/classifieds/search/facets/handlers/BaseSearchHandler.vue'
import ColorValueSearchHandler from '~/components/car/classifieds/search/facets/handlers/ColorValueSearchHandler.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import SearchService from '~/services/search/SearchService'
export default Vue.extend({
  components: { ColorValueSearchHandler },
  extends: BaseSearchHandler,
  computed: {
    ...mapDeps({ searchService: SearchService }),
    blackCheckmarksColorsIds() {
      return [21, 15, 9, 3, 13, 16, 20]
    }
  },
  methods: {
    hasBlackCheckmark(optionId: string): boolean {
      return this.blackCheckmarksColorsIds.includes(Number(optionId))
    }
  }
})
